import React from "react";
import styled from "styled-components";
import grain from "./../../assets/images/grain.svg";

export const TutorialContentArea = styled.div`
  background-color: #463048;
  background-blend-mode: multiply;
  padding: 10px;
  border-radius: 50px;
  color: white;
  padding-left: 20px;
  padding-right: 20px;
  margin-left: -10px;
  font-size: 12.5px;
  font-weight: 600;
  width: 70%;
  position: relative;
  text-align: center;
  &:before {
    content: "";
    width: 0px;
    height: 0px;
    background-image: url(${grain});
    position: absolute;
    border-left: 22px solid #463048;
    border-right: 0px solid transparent;
    border-top: 14px solid #463048;
    border-bottom-left-radius: 13px;
    transform: rotate(270deg);
    left: 25px;
    bottom: -12px;
  }
`;
